// Build / Version
const {version, build} = require('app/shared-view/version');

module.exports = {

    // this is    WEB
    platform: {
        mobile: false,
        web: true
    },

    version: version,
    build: build,

    // LIVE-PRODUCTION CONFIG
    apiUrl: "//www.goodday.work/api/app/",
    authApi: "//www.goodday.work/api/auth/",
    presenceUrl: "wss://www.goodday.work/presence/",
    apiIntegration: "//www.goodday.work/api/integration/",
    apiAttachment: "//www.goodday.work/api/app/attachment/",
    apiSharedView: "//share.goodday.work/api/",

    routing: require('../gd/router'),

    devMode: false,

    defaultSkin: 'light',

    skins: {
        blue: {
            name: 'Blue',
            color: '#0b7fc3'
        }
    },

    assetsPath: '',
    // assetsPath: '//dr1a599faqwk2.cloudfront.net/app/web',
    mediaPath: 'https://www.goodday.work/media/',
    googleApiKey: 'AIzaSyBQUc_dGz3rUYYcky6fc-QpjZ59DeEg2h4'    // *.goodday.work

};
